<template>
  <button
    class="undo-card rounded-m bg-secondary-secondary-disabled flex items-center justify-between h-full pl-200 pr-100"
    type="button"
    @click="emit('undo')"
  >
    <span class="undo-card-label paragraph-regular text-secondary-secondary">
      {{ $t('editor.playlist.undo.label') }}
    </span>

    <div class="paragraph-regular text-primary-primary font-medium flex items-center gap-100">
      <span class="font-medium">{{ $t('editor.playlist.undo.button') }}</span>
      <LcIcon name="reset" size="medium" />
    </div>
  </button>
</template>

<script lang="ts" setup>
type Emits = {
  undo: []
}

const emit = defineEmits<Emits>()
</script>

<style lang="scss" scoped>
.undo-card {
  border: token('size/border/100') solid token('color/border/primary/primary');
  cursor: pointer;
}
</style>
